import momentTimezone from 'moment-timezone';
import React, {memo, useCallback, useContext, useMemo} from 'react';
import {useIntl} from 'react-intl';
import {ThemeContext} from '../../apiContexts';
import LoadingBar from '../../components/loadingBar';
import ReactTable from '../../components/reactTable';
import {getColumnWidth, getWrappedRowHeight, WRAP_COLUMN_MAX_WIDTH} from '../../helpers/report';
import {Header, ListStyle} from './styles';
import SelectDeviceButton from './selectDeviceButton';

const EventList = ({
                       className,
                       data,
                       timezone,
                       onSelect,
                       loading,
                       ...props
                   }) => {
    const theme = useContext(ThemeContext);
    const intl = useIntl();

    // O texto da observação quebra linha, em vez de a coluna alargar sem limite (o comando enviado pode ter
    // centenas de caracteres). A largura limita e a altura de cada linha sai do texto.
    const detailWidth = useMemo(
        () => Math.min(getColumnWidth(data, 'detail', intl.formatMessage({id: 'reportObservation'})), WRAP_COLUMN_MAX_WIDTH),
        [data, intl],
    );

    const columns = useMemo(
        () => [
            {
                Header: intl.formatMessage({id: 'positionFixTime'}),
                accessor: 'eventTime',
                Cell: ({cell: {value}}) =>
                    momentTimezone(value)
                        .tz(timezone)
                        .format(intl.formatMessage({id: 'dateTimeLongFormat'})),
                minWidth: 200,
            },
            {
                Header: intl.formatMessage({id: 'sharedName'}),
                accessor: 'name',
                minWidth: 200,
                width: getColumnWidth(data, 'name', intl.formatMessage({id: 'sharedName'})),
            },
            {
                Header: intl.formatMessage({id: 'sharedType'}),
                accessor: 'type',
                width: getColumnWidth(data, 'type', intl.formatMessage({id: 'sharedType'})),
            },
            {
                Header: intl.formatMessage({id: 'reportObservation'}),
                accessor: 'detail',
                width: detailWidth,
                wrap: true,
            },
        ],
        [data, timezone, intl, detailWidth],
    );

    const getRowHeight = useCallback((row) => getWrappedRowHeight(row.detail, detailWidth), [detailWidth]);

    const selectItem = (props) => onSelect(props);

    return (
        <ListStyle theme={theme} className="custom-shadow-2">
            <Header>
                <h5>{intl.formatMessage({id: 'eventHistory'})}</h5>
                <SelectDeviceButton />
            </Header>
            {loading ? (
                <LoadingBar/>
            ) : (
                <ReactTable data={data} columns={columns} selectItem={selectItem} getRowHeight={getRowHeight}/>
            )}
        </ListStyle>
    );
};

export default memo(EventList);
